import React from "react";
import { API_BASE } from "../../../../utils/api";
import { getAppConfig } from "../../../../utils/appConfig";

/**
 * CategoryCard Component
 * Displays individual category with image, name, and description
 */
const CategoryCard = ({ category, onClick }) => {
  const { defaultImage } = getAppConfig();

  const handleClick = (e) => {
    e.stopPropagation();
    onClick(category);
  };

  return (
    <div
      onClick={handleClick}
      className={`group cursor-pointer h-[280px] flex flex-col rounded-lg overflow-hidden transition-all hover:shadow-xl relative ${
        category.isVisible
          ? "bg-white border border-gray-200"
          : "bg-gray-50 border-2 border-dashed border-gray-300"
      }`}
    >
      {/* Not Available Badge */}
      {!category.isVisible && (
        <div className="absolute top-3 right-3 z-10">
          <div className="bg-gradient-to-r from-gray-600 to-gray-700 text-white px-3 py-1.5 rounded-full shadow-lg flex items-center gap-1.5">
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
              />
            </svg>
            <span className="text-xs font-semibold">Hidden</span>
          </div>
        </div>
      )}

      {/* Category Image */}
      <div className="relative h-[150px] overflow-hidden">
        <img
  src={
    category.images && category.images.length > 0
      ? `${API_BASE}${category.images[0]}`
      : defaultImage
      ? `${API_BASE}${defaultImage}`
      : "/img/finglider_logo.jpg"
  }
  onError={(e) => {
    e.target.onerror = null;
    e.target.src = defaultImage
      ? `${API_BASE}${defaultImage}`
      : "/img/finglider_logo.jpg";
  }}
  alt={category.name || "No Image Available"}
  className={`w-full h-full object-cover group-hover:scale-110 transition-transform duration-300 ${
    !category.isVisible ? "opacity-50 grayscale" : ""
  }`}
/>
      </div>

      {/* Category Content */}
      <div className="flex-1 p-4 flex flex-col">
        <h3
          className={`font-semibold text-sm line-clamp-2 h-[3.2em] mb-3 ${
            !category.isVisible ? "text-gray-500" : ""
          }`}
          title={category.name}
        >
          {category.name}
        </h3>
        <p
          className={`text-xs line-clamp-2 h-[3.2em] ${
            !category.isVisible ? "text-gray-400" : "text-gray-600"
          }`}
        >
          {category.description}
        </p>
      </div>
    </div>
  );
};

export default CategoryCard;
